import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";
import { CONTAINER, SERVICE_ORDER, SERVICES_DEFAULTS } from "@/components/home/data";
import { useMenu, useBlock } from "@/lib/content";
import { absoluteUrl } from "@/lib/api";

export const ServicesBento = () => {
  const { menu: MENU } = useMenu();
  const home = useBlock("home", null);
  const s = { ...SERVICES_DEFAULTS, ...(home?.services || {}) };
  const cards = { ...SERVICES_DEFAULTS.cards, ...(home?.services?.cards || {}) };
  return (
  <section data-testid="services-bento" className="py-24">
    <div className={CONTAINER}>
      <Reveal>
        <p className="font-cli text-xs tracking-[0.2em] uppercase text-purple-900 mb-3">› {s.eyebrow}</p>
        <h2 className="font-heading text-3xl md:text-5xl font-semibold tracking-tight text-slate-900 max-w-3xl leading-[1.08]">
          {s.heading}
        </h2>
        <p className="mt-4 text-slate-600 text-base md:text-lg max-w-2xl">
          {s.intro}
        </p>
      </Reveal>

      <Stagger className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {SERVICE_ORDER.map((key) => {
          const entry = MENU.find((m) => m.key === key);
          if (!entry) return null;
          const card = cards[key] || {};
          const img = card.image ? absoluteUrl(card.image) : (SERVICES_DEFAULTS.cards[key] || {}).image;
          return (
            <StaggerItem key={key}>
              <Link
                to={entry.href}
                data-testid={`service-card-${key}`}
                className="group block h-full rounded-2xl border border-slate-200 bg-white overflow-hidden hover:-translate-y-1 hover:shadow-xl hover:border-pink-200 transition-all"
              >
                <div className="relative h-44 bg-gradient-to-b from-pink-50 to-white flex items-center justify-center">
                  <div className="absolute h-28 w-28 rounded-full bg-pink-300/40 blur-2xl" />
                  {/* Built-in card images ship an AVIF variant (~30% smaller);
                      browsers without AVIF (and CMS-set images) use the img src. */}
                  <picture>
                    {img && img.endsWith("-xs.webp") && <source type="image/avif" srcSet={img.replace(/\.webp$/, ".avif")} />}
                    <img src={img} alt={entry.label} className="relative h-32 object-contain group-hover:scale-105 transition-transform duration-500"  loading="lazy" decoding="async" />
                  </picture>
                </div>
                <div className="p-6 pt-4">
                  <div className="flex items-center justify-between">
                    <h3 className="font-heading text-xl font-semibold text-slate-900">{entry.label}</h3>
                    <ArrowUpRight className="h-5 w-5 text-slate-300 group-hover:text-purple-900 transition-colors" />
                  </div>
                  <p className="mt-2 text-sm text-slate-500 leading-relaxed">{card.blurb}</p>
                  <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-purple-900">Explore <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" /></span>
                </div>
              </Link>
            </StaggerItem>
          );
        })}
      </Stagger>
    </div>
  </section>
  );
};
